import { render, staticRenderFns } from "./confirm-order.vue?vue&type=template&id=d104962e&scoped=true"
import script from "./confirm-order.vue?vue&type=script&lang=js"
export * from "./confirm-order.vue?vue&type=script&lang=js"
import style0 from "./confirm-order.vue?vue&type=style&index=0&id=d104962e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d104962e",
  null
  
)

export default component.exports